import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { request } from './utils/https.js'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'


// 注册 swiper 的自定义元素
import { register } from 'swiper/element/bundle'
register() // 💥 必须注册！


const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.config.globalProperties.request = request
app.use(ElementPlus).use(store).use(router).mount('#app')
